import {
  Grid,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import * as React from "react";
import { useSelector } from "react-redux";
import "./alertModal.css";

export default function AlertModal() {
  const errors = useSelector((state) => state.errors);
  const [openModal, setOpenModal] = React.useState(false);

  React.useEffect(() => {
    if (errors === "timeout") {
      setOpenModal(true);
    }
  }, [errors]);

  return (
    <Dialog open={openModal} maxWidth="xs" fullWidth>
      <DialogContent>
        <Typography variant="body2">
          This query has timed out, please check your internet connection. If
          the issue persists, the query may be better suited to a bulk search.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => setOpenModal(false)}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
